// Module
var code = "<div class=\"MemberCardImg\"> <img ng-src=\"{{ MemberCardImg.imgSrc }}\" alt=\"Member Card\"/> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/cards/memberCardImg/memberCardImg.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;